export default "__VITE_ASSET__rj8NvU1A__"